import React from "react";
import { Index, Configure, useInstantSearch } from 'react-instantsearch';
import ProductCollections from "./ProductCollections";
import ProductHits from "./ProductHits";
import BlogHits from "./BlogHits";

export default function SearchResults() {
  return (
    <div className="w-full flex flex-col flex-nowrap h-full overflow-auto py-7">
      <div className="flex flex-wrap flex-col-reverse lg:flex-row justify-between text-white max-w-[90%] lg:max-w-[90%] w-full mx-auto">
        <div className="w-full lg:w-[37%] mb-5">
          <Index indexName="collections">
            <Configure hitsPerPage={10}/>
            <ProductCollections/>
            <div className="flex flex-col mb-7">
              {/*<p className="text-lg font-bold mx-2 pb-[7px]">*/}
              {/*  Popular Suggestions*/}
              {/*</p>*/}
              {/*<Index indexName="products">*/}
              {/*  <TrendingItems*/}
              {/*      limit={5}*/}
              {/*      itemComponent={(item) => (*/}
              {/*        <Link*/}
              {/*            to={`/products/${item.handle}`}*/}
              {/*            className={`no-underline text-sm text-white lg:text-[15px] h-9 p-2 box-border flex items-center justify-center text-center cursor-pointer`}*/}
              {/*        >*/}
              {/*          <SvgSearch*/}
              {/*              style={{ width: 16, height: 16, marginRight: 5 }}*/}
              {/*          />*/}
              {/*          {item.title}*/}
              {/*        </Link>*/}
              {/*      )}*/}
              {/*  />*/}
              {/*</Index>*/}
            </div>
          </Index>
          <Index indexName="blogs">
            <Configure hitsPerPage={3}/>
            <BlogHits />
          </Index>
        </div>
        <div className="w-full lg:w-[61%] mb-5">
          <Index indexName="products">
            <Configure hitsPerPage={4}/>
            <ProductHits/>
          </Index>
        </div>
      </div>
    </div>
  )
}
